import { render, staticRenderFns } from "./UnitEditComponent.vue?vue&type=template&id=1f1a5b58&"
import script from "./UnitEditComponent.vue?vue&type=script&lang=js&"
export * from "./UnitEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports